import { useMutation } from "@apollo/client"
import { client } from "../graphql-saleor/client"
import { STRIPE_TRANSACTION_INITIALIZE } from "../graphql-saleor/mutations/stripeTransactionInitialize"
import { STRIPE_APP_GATEWAY } from "../utils/saleor-constants"

interface StripeTransactionInitializeInput {
  checkoutId: string
  amount?: number
  currency?: string
  paymentGeteway?: string
  paymentMethodTypes?: string[]
}

export const useStripeTransactionInitialize = () => {
  const [stripeTransactionInitialize, { data, loading, error }] = useMutation(STRIPE_TRANSACTION_INITIALIZE, {
    client: client,
  })

  const executeStripeTransactionInitialize = (input: StripeTransactionInitializeInput) => {
    return stripeTransactionInitialize({
      variables: {
        checkoutId: input.checkoutId,
        paymentGateway: input.paymentGeteway || STRIPE_APP_GATEWAY,
        amount: input.amount,
        data: {
          paymentMethodTypes: input.paymentMethodTypes,
          amount: input.amount,
          currency: input.currency,
        },
      },
    })
  }
  return {
    data: data,
    error,
    loading,
    stripeTransactionInitialize: executeStripeTransactionInitialize,
  }
}
